import {
  PluginDownSamplingSchema_2023_08_20,
  PluginDownSamplingType_2023_08_20,
} from "./2023-08-20";

export const PluginDownSamplingSchema = PluginDownSamplingSchema_2023_08_20;
export type PluginDownSamplingType = PluginDownSamplingType_2023_08_20;
